<div class="row justify-content-center allergy-card">
    
    <div class="col-6 col-sm-5 col-md-3" [ngStyle]="{'display': familyHistories.length < 1 ? 'block' : 'none'}">
        <div class="bg-info card h-100 mb-3 p-3 text-center text-white" (click)="showSaveFamilyHistoryModal()">
            <span class="icon bg-white mb-3"><img height="23" src="assets/images/Icons/plus.svg"></span>
            <h6 class="font-weight-normal mb-0">{{'family_history.family_history_addFamilyHistory'|translate}}</h6>
        </div>
    </div>
    <div class="col-6 col-sm-5 col-md-3" [ngStyle]="{'display': familyHistories.length < 1 ? 'block' : 'none'}">
        <div class="card mb-3 h-100 p-3 text-center text-info"
            (click)="familyHistories.length < 1 ? onNoKnownFamilyHistory() : ''">
            <span class="icon mb-3"><img height="23" src="assets/images/Icons/cross.svg"></span>
            <h6 class="font-weight-normal mb-0">{{'family_history.family_history_noKnownFamilyHistory'|translate}}</h6>
        </div>
    </div>

    <!--<div class="col-12" [ngStyle]="{'display': familyHistories.length < 1 ? 'none' : 'block'}">
      <button class="btn btn-primary btncare " style="float: right;" type="button" (click)="showSaveFamilyHistoryModal()">{{'button.add_familyhistory'|translate}}</button>
    </div>-->


</div>

<!-- <ng-container *ngIf="!isLoadingPE"> -->
<ng-container *ngIf="familyHistories.length >0 else notFoundPA">
    <div class="container flex-grow-1 overflow-auto">
        <div class="specialist-list ">
          <div class="form-row">
            <div class="col-12 mb-4 mt-2" [ngStyle]="{'display': familyHistories.length < 1 ? 'none' : 'block'}">
              <button class="btn btn-primary btncare " style="float: right;" type="button" (click)="showSaveFamilyHistoryModal()">{{'button.add_familyhistory'|translate}}</button>
            </div>
            <div class="col-lg-6" *ngFor="let item of familyHistories">
              <div class="card mb-4 pb-3">
                <div class="card-body p-0">
                  <div class="align-items-center d-flex justify-content-between mb-2">
                    <h6 class="font-weight-bold mb-0" *ngIf="item.relationship == 'BRO'else a">{{'family_history.family_history_brother'|translate}}</h6>
                    <ng-template #a>
                      <h6 class="font-weight-bold mb-0" *ngIf="item.relationship == 'FTH'else b">
                        {{'family_history.family_history_father'|translate}}
                      </h6>
                      <ng-template #b>
                        <h6 class="font-weight-bold mb-0" *ngIf="item.relationship == 'GGRMTH'else c">
                          {{'family_history.family_history_greatGrandmother'|translate}}
                        </h6>
                        <ng-template #c>
                          <h6 class="font-weight-bold mb-0"
                              *ngIf="item.relationship == 'GGRPRN'else d">
                            {{'family_history.family_history_greatGrandparent'|translate}}
                          </h6>
                          <ng-template #d>
                            <h6 class="font-weight-bold mb-0"
                                *ngIf="item.relationship == 'GRFTH'else e">
                              {{'family_history.family_history_grandfather'|translate}}
                            </h6>
                            <ng-template #e>
                              <h6 class="font-weight-bold mb-0"
                                  *ngIf="item.relationship == 'GRMTH'else f">
                                {{'family_history.family_history_grandmother'|translate}}
                              </h6>
                              <ng-template #f>
                                <h6 class="font-weight-bold mb-0"
                                    *ngIf="item.relationship == 'GRNDDAU'else g">
                                  {{'family_history.family_history_granddaughter'|translate}}
                                </h6>
                                <ng-template #g>
                                  <h6 class="font-weight-bold mb-0"
                                      *ngIf="item.relationship == 'GRNDSON'else h">
                                    {{'family_history.family_history_grandson'|translate}}
                                  </h6>
                                  <ng-template #h>
                                    <h6 class="font-weight-bold mb-0"
                                        *ngIf="item.relationship == 'HSIB'else i">
                                      {{'family_history.family_history_halfSibling'|translate}}
                                    </h6>
                                    <ng-template #i>
                                      <h6 class="font-weight-bold mb-0"
                                          *ngIf="item.relationship == 'MTH'else j">
                                        {{'family_history.family_history_mother'|translate}}
                                      </h6>
                                      <ng-template #j>
                                        <h6 class="font-weight-bold mb-0"
                                            *ngIf="item.relationship == 'SIS'else k">
                                          {{'family_history.family_history_sister'|translate}}
                                        </h6>
                                        <ng-template #k>
                                          <h6 class="font-weight-bold mb-0"
                                              *ngIf="item.relationship == 'SPS'else l">
                                            {{'family_history.family_history_spouse'|translate}}
                                          </h6>
                                          <ng-template #l>
                                            <h6 class="font-weight-bold mb-0">
                                              {{item.relationship == '' ? 'N/A' : item.relationship }}
                                            </h6>
                                          </ng-template>
                                        </ng-template>
                                      </ng-template>
                                    </ng-template>
                                  </ng-template>
                                </ng-template>
                              </ng-template>
                            </ng-template>
                          </ng-template>
                        </ng-template>
                      </ng-template>
                    </ng-template>
                    <div class="ctabtns d-flex" *ngIf="item.recounciledData=='True'">
                      <!--<a (click)="editFamilyHX(item)" class="mr-3"><i title="{{'link.edit'|translate}}"
                        class="fas fa-edit text-dark"></i></a>-->
                      <a href="javascript:void(0)" (click)="setDeleteFamilyHX(item)" class="text-dark">
                        {{'link.delete'|translate}}
                        
                      </a>
                    </div>
                    <div class="ctabtns d-flex"  *ngIf="item.recounciledData=='False'">
                      <!--<a (click)="editFamilyHX(item)" class="mr-3"><i title="{{'link.edit'|translate}}"
                            class="fas fa-edit text-dark"></i></a>-->
                      <a href="javascript:void(0)"  (click)="onDeleteFamilyHIstory()"  class="text-dark">
                        {{'link.delete'|translate}}
                      
                      </a>
                    </div>
                  </div>
                  <!--<div class="mb-2" [ngStyle]="{'display' : intakeFieldsSetting.IsNameAllowed ? '' : 'none'}">
          <span class="text-muted font-weight-bold mr-1">{{'family_history.family_history_name'|translate}}:</span>
            <span>{{item.name || 'N/A'}}</span>
        </div>-->
                  <div class="mb-2">
                    <span>{{'family_history.family_history_diagnosis'|translate}}: </span>
                    <span class="text-muted font-weight-bold mr-1">{{(item.familyHistoryDiagnosisDescription  | titlecase)|| 'N/A'}}</span>
                  </div>
                  <!--<div class="mb-2" [ngStyle]="{'display' : intakeFieldsSetting.IsAgeAllowed ? '' : 'none'}">
          <span class="text-muted font-weight-bold mr-1">{{'family_history.family_history_age'|translate}}:</span>
            <span>{{item.age || 'N/A'}}</span>
        </div>-->
                  <!--<div class="mb-2"
            [ngStyle]="{'display' : intakeFieldsSetting.IsAgeOnSetAllowed ? '' : 'none'}">
          <span class="text-muted font-weight-bold mr-1">{{'family_history.family_history_ageAtOnset'|translate}}:</span>
            <span>{{item.ageAtOnset || 'N/A'}}</span>
        </div>-->
                <div [ngStyle]="{'display' : intakeFieldsSetting.IsDeceasedAllowed ? '' : 'none'}">
                  <span>{{'family_history.family_history_status'|translate}}: </span>
                  <span class="text-muted font-weight-bold mr-1">
                    {{ item.isDeceased == '0' ? ('family_history.family_history_alive' | translate) :(item.isDeceased == '1' ? ('family_history.family_history_dead' | translate) : ('family_history.family_history_unkown' | translate)) }}
                  </span>


                </div>

                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
</ng-container>
<ng-template #notFoundPA>

    <div class="col-12 mt-4 text-center px-0">
      <p class="mb-0 text-danger">{{'family_history.family_history_noFamilyHistory'|translate}}.</p>
    </div>
</ng-template>
<!-- </ng-container> -->

<!-- add  -->
<form [formGroup]="formFamilyHistory">
    <div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse modal-full-height"
        id="modalSaveFamilyHistory">
        <div class="modal-dialog modal-dialog-scrollable">
            <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">{{'family_history.family_history_addFamilyHistory'|translate}}</h5>
                    <button type="button" class="close" data-dismiss="modal" (click)="reset()" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="insurance-tab">
                      <div class="form-row">
                        <div class="form-group col-md-12" id="relationship">
                          <div class=" form-select border-bottom">

                            <label class="form-label fw-bold">{{'family_history.family_history_relationship'|translate}}<span class="text-danger">*</span></label>

                            <select formControlName="relationship" id="main_relationship" class="form-control border-0">
                              <option value="" selected disabled>{{'family_history.family_history_selectRelationship'|translate}}</option>
                              <option value="BRO"> {{'family_history.family_history_brother'|translate}}</option>
                              <option value="FTH"> {{'family_history.family_history_father'|translate}}</option>
                              <option value="GGRMTH"> {{'family_history.family_history_greatGrandmother'|translate}}</option>
                              <option value="GGRPRN"> {{'family_history.family_history_greatGrandparent'|translate}}</option>
                              <option value="GRFTH"> {{'family_history.family_history_grandfather'|translate}}</option>
                              <option value="GRMTH"> {{'family_history.family_history_grandmother'|translate}}</option>
                              <option value="GRNDDAU"> {{'family_history.family_history_granddaughter'|translate}}</option>
                              <option value="GRNDSON"> {{'family_history.family_history_grandson'|translate}}</option>
                              <option value="HSIB"> {{'family_history.family_history_halfSibling'|translate}}</option>
                              <option value="MTH"> {{'family_history.family_history_mother'|translate}}</option>
                              <option value="SIS"> {{'family_history.family_history_sister'|translate}}</option>
                              <option value="SPS"> {{'family_history.family_history_spouse'|translate}}</option>
                            </select>

                          </div>
                          <div>
                            <span class="err"
                                  *ngIf="getFamilyForm.relationship.touched && getFamilyForm.relationship.invalid">
                              {{'family_history.family_history_selectRelationship_small'|translate}}.
                            </span>
                          </div>

                        </div>
                        <!--<div class="col-md-6"
      [ngStyle]="{'display' : intakeFieldsSetting.IsNameAllowed ? '' : 'none'}">
      <div class="form-group form-floating">
          <input type="text" placeholder="{{'family_history.family_history_name'|translate}}" maxlength="100"
              ng-pattern="/^[a-zA-Z\d]+[^a-zA-Z\d]*$/" formControlName="name"
              (keypress)="validateName($event)" class="form-control">
          <label>{{'family_history.family_history_name'|translate}}</label>
      </div>
  </div>-->
                        <!--<div class="col-md-6 col-6"
      [ngStyle]="{'display' : intakeFieldsSetting.IsAgeAllowed ? '' : 'none'}">
      <div class="form-group form-floating">
          <input min="1" max="150" placeholder="{{'family_history.family_history_age'|translate}}" formControlName="age" type="number"
              class="form-control">
          <label>{{'family_history.family_history_age'|translate}}</label>
          <span class="err"
              *ngIf="getFamilyForm.age.errors?.max && getFamilyForm.age.touched">
            <small>{{'family_history.family_history_age_cannot_be_greater_than_150'|translate}}.</small>
          </span>
      </div>
  </div>-->
                        <!--<div class="col-md-6 col-6"
      [ngStyle]="{'display' : intakeFieldsSetting.IsAgeOnSetAllowed ? '' : 'none'}">
      <div class="form-group form-floating">
          <input min="1" max="150" placeholder="{{'family_history.family_history_ageAtOnset'|translate}}" formControlName="ageonset"
              type="number" class="form-control">
          <label>{{'family_history.family_history_ageAtOnset'|translate}}</label>
          <span class="err"
              *ngIf="getFamilyForm.ageonset.touched || getFamilyForm.ageonset.dirty && getFamilyForm.ageonset.invalid">
            <small *ngIf="getFamilyForm.ageonset.errors?.max else e">{{'family_history.family_history_ageAtOnset_cannot_be_greater_than_150'|translate}}.</small>
              <ng-template #e>
                <small *ngIf="getFamilyForm.age.value != 0 && getFamilyForm.ageonset.value > getFamilyForm.age.value">{{'family_history.family_history_ageAtOnset_cannot_be_greater_than_age'|translate}}.</small>
              </ng-template>
          </span>

      </div>
  </div>-->
                        <!-- Common disease -->

                      <div class="form-group col-md-12">
                        <div class="has-search form-select border-bottom">
                          <label class="form-label fw-bold">{{'family_history.family_history_diagnosis'|translate}}<span class="text-danger">*</span></label>
                          <select formControlName="diagnosis" name="commondisease" id="commonDisease"
                                  class="form-control border-0"
                                  (change)="onChangeDisease($event)">
                            <option value="">{{'family_history.family_history_dignosis_placeholder'|translate}}</option>
                            <option *ngFor="let d of commonDisease;" [value]="d.diseaseId">
                              {{d.diseaseDescription}}
                            </option>
                          </select>
                        </div>
                        <div>
                          <span class="err"
                                *ngIf="getFamilyForm.diagnosis.touched && getFamilyForm.diagnosis.invalid">
                            {{'family_history.family_history_selectDiagnosis'|translate}}
                          </span>
                        </div>
                      </div>




                        <!-- diagnosis -->
                        <!--<div class="form-group col-md-12">
    <div class=" border-bottom" ngbDropdown #diagnosisDrop="ngbDropdown">
      <label class="form-label fw-bold">{{'family_history.family_history_diagnosis'|translate}}<span class="text-danger">*</span></label>
      <input ngbDropdownAnchor (focus)="diagnosisDrop.open()" aria-haspopup="true"
             aria-expanded="false" type="text" (keyup)="getDiagnosis($event)"
             id="searchdiagnosisdropdown" formControlName="diagnosis"
             placeholder="{{'family_history.family_history_searchDiagnosis'|translate}}" class="form-control border-0">

      <div ngbDropdownMenu class="custom-menu" aria-labelledby="searchdiagnosisdropdown"
           [ngClass]="{'d-none': dNonediagnosis}">
        <button ngbDropdownItem *ngIf="isLoading">
          <span>{{'family_history.family_history_loading'|translate}}</span>
        </button>
        <button ngbDropdownItem *ngIf="(noRecs && !isLoading && diagnosis.length == 0)">
          {{'family_history.family_history_noRecordsFound'|translate}}
        </button>
        <button ngbDropdownItem *ngFor="let d of diagnosis"
                (click)="onSelectDiagnos(d)">{{d.ICD10_DESCRIPTION}}</button>
      </div>

    </div>
    <div>
      <span class="err"
            *ngIf="getFamilyForm.diagnosis.touched && getFamilyForm.diagnosis.invalid">
        {{'family_history.family_history_selectDiagnosis'|translate}}
      </span>
    </div>

  </div>-->

                      <div class="col-md-12"
                           [ngStyle]="{'display' : intakeFieldsSetting.IsDeceasedAllowed ? '' : 'none'}">
                        <!--<label class="form-label d-block fw-bold pb-2">{{'family_history.family_history_deceased'|translate}}</label>
                        <div class="custom-control custom-radio custom-control-inline">
                          <input type="radio" name="radioNo" id="customRadioInline1" value="1"
                                 (change)="onDeceasedChanged($event)" class="custom-control-input">
                          <label class="custom-control-label" for="customRadioInline1">{{'family_history.family_history_yes'|translate}}</label>
                        </div>
                        <div class="custom-control custom-radio custom-control-inline">

                          <input type="radio" name="radioNo" value="0" id="customRadioInline2" #radioNo checked (change)="onDeceasedChanged($event)" class="custom-control-input">

                          <label class="custom-control-label" for="customRadioInline2">{{'family_history.family_history_no'|translate}}</label>
                        </div>-->
                        <p class="mb-2 fw-bold form-label">{{'family_history.family_history_status'|translate}} </p>
                        <ul class="list-inline list-unstyled mb-0 new-symptoms-list" [ngClass]="{'rtl': isRtl}">
                          <li class="list-inline-item ">
                            <div class="custom-control custom-radio">
                              <input class="custom-control-input" type="radio" name="radioNo" value="0" id="customRadioInline2" #radioNo checked (change)="onDeceasedChanged($event)">
                              <label style="margin-bottom:0px !important;" class="custom-control-label cursor-pointer" for="customRadioInline2">
                                {{'family_history.family_history_alive'|translate}}
                              </label>

                            </div>
                          </li>
                          <li class="list-inline-item rd" style="margin-left: 30px;">
                            <div class="custom-control custom-radio">
                              <input class="custom-control-input" type="radio" name="radioNo" id="customRadioInline1" value="1"
                                     (change)="onDeceasedChanged($event)">
                              <label style="margin-bottom:0px !important;" class="custom-control-label cursor-pointer" for="customRadioInline1">
                                {{'family_history.family_history_dead'|translate}}
                              </label>
                            </div>
                          </li>

                          <li class="list-inline-item rd" style="margin-left: 30px;">
                            <div class="custom-control custom-radio">
                              <input class="custom-control-input" type="radio" name="radioNo" value="2" id="customRadioInline3" (change)="onDeceasedChanged($event)">
                              <label style="margin-bottom:0px !important;" class="custom-control-label cursor-pointer" for="customRadioInline3">
                                {{'family_history.family_history_unkown'|translate}}
                              </label>

                            </div>
                          </li>
                        </ul>
                      </div>
                      </div>
                    </div>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-outline-primary " data-dismiss="modal" (click)="reset()">{{'button.close'|translate}}</button>
                  <button type="button" (click)="onSaveFamilyHistory()" class="btn btn-primary ">{{'button.save'|translate}}</button>
                </div>
            </div>
        </div>
    </div>
</form>

<!-- edit  -->
<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse modal-full-height"
    id="editFamilyHistoryModal">
    <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{'family_history.family_history_editFamilyHistory'|translate}}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="insurance-tab">
                    <div class="form-row">
                        <div class="col-md-12">
                          <div class="form-group form-select form-floating">

                            <!--<select class="form-control" [(ngModel)]="editFH.relationship">
      <option *ngFor="let item of relations" [selected]="item.val == editFH.relationship"
          value="{{item.val}}">{{item.label}}</option>
  </select>-->

                            <select class="form-control" [(ngModel)]="editFH.relationship">
                              <option value="BRO" [attr.selected]="editFH.relationship == 'BRO' ? 'selected' : ''"> {{'family_history.family_history_brother'|translate}}</option>
                              <option value="FTH" [attr.selected]="editFH.relationship == 'FTH' ? 'selected' : ''"> {{'family_history.family_history_father'|translate}}</option>
                              <option value="GGRMTH" [attr.selected]="editFH.relationship == 'GGRMTH' ? 'selected' : ''"> {{'family_history.family_history_greatGrandmother'|translate}}</option>
                              <option value="GGRPRN" [attr.selected]="editFH.relationship == 'GGRPRN' ? 'selected' : ''"> {{'family_history.family_history_greatGrandparent'|translate}}</option>
                              <option value="GRFTH" [attr.selected]="editFH.relationship == 'GRFTH' ? 'selected' : ''"> {{'family_history.family_history_grandfather'|translate}}</option>
                              <option value="GRMTH" [attr.selected]="editFH.relationship == 'GRMTH' ? 'selected' : ''"> {{'family_history.family_history_grandmother'|translate}}</option>
                              <option value="GRNDDAU" [attr.selected]="editFH.relationship == 'GRNDDAU' ? 'selected' : ''"> {{'family_history.family_history_granddaughter'|translate}}</option>
                              <option value="GRNDSON" [attr.selected]="editFH.relationship == 'GRNDSON' ? 'selected' : ''"> {{'family_history.family_history_grandson'|translate}}</option>
                              <option value="HSIB" [attr.selected]="editFH.relationship == 'HSIB' ? 'selected' : ''"> {{'family_history.family_history_halfSibling'|translate}}</option>
                              <option value="MTH" [attr.selected]="editFH.relationship == 'MTH' ? 'selected' : ''"> {{'family_history.family_history_mother'|translate}}</option>
                              <option value="SIS" [attr.selected]="editFH.relationship == 'SIS' ? 'selected' : ''"> {{'family_history.family_history_sister'|translate}}</option>
                              <option value="SPS" [attr.selected]="editFH.relationship == 'SPS' ? 'selected' : ''"> {{'family_history.family_history_spouse'|translate}}</option>
                            </select>
                            <label>{{'family_history.family_history_relationship'|translate}}<span class="text-danger">*</span></label>
                          </div>
                        </div>
                        <!--<div class="col-md-6" [ngStyle]="{'display' : intakeFieldsSetting.IsNameAllowed ? '' : 'none'}">
                            <div class="form-group form-floating">
                                <input type="text" placeholder="{{'family_history.family_history_name'|translate}}" ng-pattern="/^[a-zA-Z\d]+[^a-zA-Z\d]*$/"
                                    [(ngModel)]="editFH.name" maxlength="100" (keypress)="validateName($event)"
                                    class="form-control">
                                <label>{{'family_history.family_history_name'|translate}}</label>
                            </div>
                        </div>-->
                        <!--<div class="col-md-6 col-6"
                            [ngStyle]="{'display' : intakeFieldsSetting.IsAgeAllowed ? '' : 'none'}">
                            <div class="form-group form-floating">
                                <input min="1" max="150" placeholder="{{'family_history.family_history_age'|translate}}" #age="ngModel" [(ngModel)]="editFH.age"
                                    type="number" class="form-control">
                                <label>{{'family_history.family_history_age'|translate}}</label>
                                <span class="err" *ngIf="age.errors?.max && age.touched">
                                  <small>{{'family_history.family_history_age_cannot_be_greater_than_150'|translate}}.</small>
                                </span>
                            </div>
                        </div>-->
                        <!--<div class="col-md-6 col-6"
                            [ngStyle]="{'display' : intakeFieldsSetting.IsAgeOnSetAllowed ? '' : 'none'}">
                            <div class="form-group form-floating">
                                <input min="1" max="150" placeholder="{{'family_history.family_history_ageAtOnset'|translate}}" #ageAtOnset="ngModel"
                                    [(ngModel)]="editFH.ageAtOnset" type="number" class="form-control">
                                <label>{{'family_history.family_history_ageAtOnset'|translate}}</label>
                                <span class="err" *ngIf="ageAtOnset.touched || ageAtOnset.dirty && ageAtOnset.invalid">
                                  <small *ngIf="ageAtOnset.errors?.max else e">{{'family_history.family_history_ageAtOnset_cannot_be_greater_than_150'|translate}}.</small>
                                    <ng-template #e>
                                      <small *ngIf="age.value != 0 && ageAtOnset.value > age.value">{{'family_history.family_history_ageAtOnset_cannot_be_greater_than_age'|translate}}.</small>
                                    </ng-template>
                                </span>
                            </div>
                        </div>-->
                        <div class="col-md-12">
                            <div class="form-group form-floating">
                                <input #diag="ngModel" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                                    type="text" (keyup)="getDiagnosis($event)" placeholder="{{'family_history.family_history_searchDiagnosis'|translate}}"
                                    [(ngModel)]="editFH.familyHistoryDiagnosisDescription" class="form-control"
                                    required>
                                <label>{{'family_history.family_history_diagnosis'|translate}}<span class="text-danger">*</span></label>
                                <div class="dropdown-menu custom-menu" aria-labelledby="dropdownMenu2">
                                    <ul class="list-unstyled symptoms-list item-list mb-0">
                                        <li class="dropdown-item" *ngIf="isLoading">
                                          <span>{{'family_history.family_history_loading'|translate}}</span>
                                        </li>
                                        <li *ngIf="noRecs && !isLoading && diagnosis.length == 0">{{'family_history.family_history_noRecordsFound'|translate}}</li>
                                        <li class="dropdown-item" *ngFor="let d of diagnosis"
                                            (click)="onSelectDiagnosUpdate(d)">
                                            <span class="d-block ">
                                                <span><b>{{d.ICD10_DESCRIPTION}}</b></span>
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                                <span class="err" *ngIf="!editFH.familyHistoryDiagnosisDescription">
                                  <small>{{'family_history.family_history_selectDiagnosis'|translate}}</small>
                                </span>
                            </div>
                        </div>
                        <div class="col-md-12"
                            [ngStyle]="{'display' : intakeFieldsSetting.IsDeceasedAllowed ? '' : 'none'}">
                          <label class="d-block">{{'family_history.family_history_deceased'|translate}}</label>
                            <div class="custom-control custom-radio custom-control-inline">
                                <input [attr.checked]="editFH.isDeceased == '1' ? true : null" type="radio" name="rad"
                                    id="radyes" value="1" (change)="onDeceasedChangedUpdate($event)"
                                    class="custom-control-input">
                                <label class="custom-control-label" for="radyes">{{'family_history.family_history_yes'|translate}}</label>
                            </div>
                            <div class="custom-control custom-radio custom-control-inline">
                                <input [attr.checked]="editFH.isDeceased == '0' ? true : null" type="radio" name="rad"
                                    value="0" id="radno" (change)="onDeceasedChangedUpdate($event)"
                                    class="custom-control-input">
                                <label class="custom-control-label" for="radno">{{'family_history.family_history_no'|translate}}</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline-primary " data-dismiss="modal">{{'button.close'|translate}}</button>
              <button type="button" (click)="onUpdateFamilyHistory()" class="btn btn-primary ">{{'button.update'|translate}}</button>
            </div>
        </div>
    </div>
</div>


<!-- delete  -->

<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="modalDeleteFamilyHistory">
   

    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-body p-4 text-center">
                <h5 class="font-weight-bolder mb-3 text-danger"><strong>{{'family_history.family_history_deleteFamilyHistoryConfirmation'|translate}}</strong></h5>
                <button type="button" class="btn btn-outline-primary mr-2" data-dismiss="modal"
                        id="closeDeleteAllergyModel">
                  {{'button.cancel'|translate}}
                </button>
                <button type="button" id="closeDeleteFamilyHistory" (click)="DeleteFamilyHX()"
                        class="btn btn-primary rbtn">
                  {{'button.delete'|translate}}
                </button>
            </div>
        </div>
    </div>
</div>
